define('common/durandal/widgets/commonClock/viewmodel',[
    'jquery',
    'underscore',
    'knockout',
    'moment'
], function($, _, ko, moment) {

    var DEFAULT_SETTINGS = {
        updateInterval: 60,
        onTick: function(){}
    };

    function Clock() {

        var self = this;

        self.unformattedTime = ko.observable({
            dd: 0,
            hh: 0,
            mm: 0,
            ss: 0
        });

        self.formattedTime = ko.pureComputed(function() {
            return self.getFormatted(self.unformattedTime());
        });

    }

    Clock.prototype.activate = function(settings) {
        var self = this;
        self.settings = _.defaults(settings, DEFAULT_SETTINGS);

        if (self.settings.endAt) {
            self.settings.endAtDate = ko.pureComputed(function() {
                return new Date(ko.unwrap(self.settings.endAt));
            });
        }

        if(ko.isObservable(self.settings.endAt)) {
            self.subscription = self.settings.endAt.subscribe(function() {
                self.start();
            });
        }

        if (self.settings.runWhen) {
            self.settings.runWhen.subscribe(function(run) {
                run ? self.start() : self.stop();
            });
        }

        self.isShowingHour = ko.pureComputed(function() {
            return self.unformattedTime().hh > 0;
        });

        self.format = ko.pureComputed(function() {

            if (settings.format) {
                return ko.unwrap(settings.format);
            }

            if (!self.settings.endAt) {
                return '%(hh)s:%(mm)s';
            }

            if (self.isShowingHour()) {
                return '%(hh)s:%(mm)s:%(ss)s';
            }

            return '%(mm)s:%(ss)s';

        });
    };

    Clock.prototype.attached = function() {
        this.start();
    };

    Clock.prototype.detached = function() {
        if (this.subscription) {
            this.subscription.dispose();
        }

        this.stop();
    };

    Clock.prototype.start = function() {
        var self = this;
        self.stop();

        self.settings.interval = window.setInterval(function() {
            var currentTime = self.update();
            if(self.settings.endAtDate){
                self.settings.onTick(self.settings.endAtDate(), currentTime);
            }
        }, this.settings.updateInterval * 1000);

        self.update();
    };

        Clock.prototype.stop = function() {
        window.clearInterval(this.settings.interval);
    };

    Clock.prototype.update = function() {

        var now = new Date();

        this.unformattedTime(this.getTime());

        if ( this.settings.endAtDate && this.settings.endAtDate() <= now ) {
            this.stop();
        }

        return now;

    };

    Clock.prototype.getTime = function() {
        var now = new Date(),
            days,
            hours,
            minutes,
            seconds,
            milliseconds;

        if (this.settings.endAt) {
            var dateTimeDiff = ko.unwrap(this.settings.endAtDate) - now; //milliseconds

            //Calculate difference from now until a future date
            dateTimeDiff = dateTimeDiff / 1000;
            seconds = ('0' + Math.max(0, Math.floor(dateTimeDiff % 60))).slice(-2);

            dateTimeDiff = dateTimeDiff / 60;
            minutes = ('0' + Math.max(0, Math.floor(dateTimeDiff % 60))).slice(-2);

            dateTimeDiff = dateTimeDiff / 60;
            hours = ('0' + Math.max(0, Math.floor(dateTimeDiff % 24))).slice(-2);

            days = ('0' + Math.max(0, Math.floor(dateTimeDiff / 24))).slice(-2);
        }
        else {
            //Calculate the current time
            hours = ('0' + now.getHours()).slice(-2),
            minutes = ('0' + now.getMinutes()).slice(-2),
            seconds = ('0' + now.getSeconds()).slice(-2);
        }

        return {
            dd: days,
            hh: hours,
            mm: minutes,
            ss: seconds
        };
    };

    /*
    * From Underscore.String extensions. http://www.diveintojavascript.com/projects/javascript-sprintf
    * Available named(!) digits from the method above
    * Fetch digit syntax: %(digitName)s
    */
    Clock.prototype.getFormatted = function(digitsHash) {
        return _.str.sprintf(this.format(), digitsHash);
    };

    return Clock;
});

